import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=d2796f58&"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports